import { Component, OnDestroy, OnInit } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { select, Store } from "@ngrx/store";
import { DataStorageService } from "assurcard-angular-library";
import { Observable, Subscription } from "rxjs";
import { filterNullOrUndefined } from 'src/app/@operators/filter-null-or-undefined';
import { ContractDto, InsurerDto, RefLanguageDto } from "src/app/api/models";
import { AppState, getState } from "src/app/state/app.state";
import { loadAgreements, resetAgreement } from "../../../../kiosk/components/agreement/state/agreement.actions";
import * as ArcHospiActions from "../../archospi/state/archospi.actions";
import { setTitle } from "../../title/state/title.actions";
import { resetContract, setAgreementChecked, setBirthdate } from "../../transaction-info/state/transaction-info.actions";
import { selectAgreement } from "../state/agreement.selectors";
import { loginLight } from "../../authentication/state/authentication.actions";

@Component({
    selector: "app-agreement",
    templateUrl: "./agreement.component.html",
    styleUrls: ["./agreement.component.scss"],
    standalone: false
})
export class AgreementComponent implements OnInit {
	public agreement$: Observable<string> = this.store.pipe(select(selectAgreement)).pipe(filterNullOrUndefined());
	public dobType: string;
	private language: RefLanguageDto;
	public insurer: InsurerDto;
	public contract: ContractDto;
	public agreementCheck = new UntypedFormControl(false, [Validators.required]);
	public agreementText: string = undefined;
	private subs: Subscription[] = [];

	constructor(private store: Store<AppState>, private dataStorage: DataStorageService) {
		this.subs.push(
			getState(this.store).subscribe(state=>{
				this.language = state.transactionInfo.selectedLanguage;
				this.insurer = state.transactionInfo.selectedInsurer;
				this.contract = state.transactionInfo.selectedContract;
				this.dobType = state.transactionInfo.selectedInsurerDobType;
			})
		);
	}

	ngOnInit() {
		this.subs.push(this.dataStorage.remove('CURRENT_LANG').subscribe());

		this.store.dispatch(
			setTitle({
				data: "TITLE_AGREEMENT",
				data2: "TITLE_AGREEMENT_INFO",
			})
		);

		const filter = {
			insurerId: this.insurer.insurerId,
			profileId: this.contract.profile.profileId,
			langCode: this.language.languageCode.toUpperCase(),
		};
		this.store.dispatch(loadAgreements(filter));
	}

	public onClickRetour() {
		this.store.dispatch(resetAgreement());
		this.store.dispatch(setAgreementChecked({ data: false }));
		this.store.dispatch(setBirthdate({ data: undefined }));
		this.store.dispatch(resetContract());
		this.store.dispatch(loginLight());
	}

	toggleAgreement() {
		this.agreementCheck.setValue(!this.agreementCheck.value);
	}

	public onClickOk() {
		this.store.dispatch(ArcHospiActions.agreementSigned());
		this.store.dispatch(setAgreementChecked({ data: true }));
	}

		ngOnDestroy(): void {
		this.subs.forEach((_) => _.unsubscribe());
	}
}
